module.exports = __webpack_public_path__ + "818552a4c202773d233fcc7d940cd97a.pdf";